import {Type} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {BUTTON_NAME} from '../common/constants';

export class DialogParams {
  public componentType: Type<any>;
  public title: string;
  public message: string;
  public html: string;
  public positiveButton: string;
  public negativeButton: string;
  public reportBtn: string;
  public deleteBtn: string;
  public checkInBtn: string;
  public subject: Subject<DialogResult>;
  public extraParams: any;
  public size: string; // 'modal-lg' or 'modal-sm' or null

  constructor(componentType: Type<any>, title: string, message: string, html: string,
              positiveButton: string, reportBtn: string, deleteBtn: string, checkInBtn: string,
              negativeButton: string, subject: Subject<DialogResult>, extraParams: any, size: string ) {
    this.componentType = componentType;
    this.title = title;
    this.message = message;
    this.html = html;
    this.positiveButton = positiveButton;
    this.reportBtn = reportBtn;
    this.deleteBtn = deleteBtn;
    this.checkInBtn = checkInBtn;
    this.negativeButton = negativeButton;
    this.subject = subject;
    this.extraParams = extraParams;
    this.size = size;
  }
}

/**
 * ダイアログ返却値のコンテナ
 */
export class DialogResult {
  public buttonName: BUTTON_NAME;
  public payload: any;

  constructor(buttonName: BUTTON_NAME, payload: any) {
    this.buttonName = buttonName;
    this.payload = payload;
  }

  isOk() {
    return this.buttonName === BUTTON_NAME.OK;
  }

  isCancel() {
    return this.buttonName === BUTTON_NAME.CANCEL;
  }

  isCheckIn() {
    return this.buttonName === BUTTON_NAME.CHECK_IN;
  }
}

/**
 * モーダルダイアログのコンポーネントが実装すべきインターフェイス
 */
export interface DialogAdapter {
  params: DialogParams;

  onModalInit();

  /**
   * ダイアログ特有「の返却データを取得する
   */
  getPayload(): any;
}



// WEBPACK FOOTER //
// /app/src/app/models/dialog-param.ts